import { getUrl, uploadData } from 'aws-amplify/storage'
import { Dispatch, SetStateAction } from 'react'

import { SaveProgress } from '../views/Profile/types'

export const uploadFileToAWS = async ({
  name,
  path,
  file,
  setSaveProgress,
  bucket,
}: {
  name: string
  path: string
  file: File
  setSaveProgress?: Dispatch<SetStateAction<SaveProgress>>
  bucket?: string
}) => {
  try {
    const operation = uploadData({
      path: `public/${path}/${name}`,
      data: file,
      options: {
        ...(bucket
          ? { bucket: { bucketName: bucket, region: 'us-east-1' } }
          : {}),
        onProgress: ({ transferredBytes, totalBytes }) => {
          if (setSaveProgress && totalBytes) {
            setSaveProgress(
              transferredBytes < totalBytes
                ? SaveProgress.InProgress
                : SaveProgress.Completed
            )
          }
        },
      },
    })
    const result = await operation.result
    return result
  } catch (err) {
    throw new Error('Unable to upload')
  }
}

export const getImageUrl = async (
  rawUrl: string | null
): Promise<string | null> => {
  if (!rawUrl || rawUrl.startsWith('http')) return rawUrl

  const path = rawUrl.startsWith('public/') ? rawUrl : `public/${rawUrl}`

  const { url } = await getUrl({ path })
  return url.toString()
}
